import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

/**
 * A panel that slides in from the right and leaves the list behind it where it was.
 *
 * Every detail in this product was a page: read one training from the register and
 * the register was gone — its filters, its scroll position, the row you were on. An
 * auditor works through a list, not one record at a time. This is EventStorii's shape
 * (`GuestDetailSheet`, `LeadDrawer`): full width on a phone, capped on a desktop, a
 * header that stays put and a body that scrolls, and the record's id in the URL so a
 * refresh or a pasted link reopens the same panel.
 *
 * `footer` is for the actions: what the person came here to do sits at the bottom, in
 * reach, however long the body is.
 */
export default function SideSheet({
  open, onOpenChange, title, description, children, footer, testid,
  width = "sm:max-w-lg", className,
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" data-testid={testid}
                    className={cn("w-full p-0 flex flex-col gap-0 border-l-0 shadow-2xl", width, className)}>
        <SheetHeader className="shrink-0 px-5 pt-5 pb-4 pr-12 border-b border-border text-left space-y-1">
          <SheetTitle className="font-heading text-xl leading-tight">{title}</SheetTitle>
          {/* Radix warns when a dialog has no description; an empty one keeps it quiet
              without announcing nothing. */}
          <SheetDescription className={cn(!description && "sr-only")}>{description || title}</SheetDescription>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>
        {footer && (
          <div className="shrink-0 px-5 py-3 border-t border-border bg-card flex flex-wrap gap-2 justify-end">
            {footer}
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
